var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loginOK)?_c('div',{attrs:{"id":"app"}},[(!this.$route.params.viewid)?_c('Header'):_vm._e(),_c('div',{staticClass:"toast hide",attrs:{"id":"Toast1"}}),_c('router-view')],1):_c('Loading',{attrs:{"title":"Connecting to Device Monitor"}})}
var staticRenderFns = []

export { render, staticRenderFns }